import { render, staticRenderFns } from "./BrandPriceAdjustment.vue?vue&type=template&id=52801edc&scoped=true&"
import script from "./BrandPriceAdjustment.vue?vue&type=script&lang=js&"
export * from "./BrandPriceAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./BrandPriceAdjustment.vue?vue&type=style&index=0&id=52801edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52801edc",
  null
  
)

export default component.exports